import PropTypes from 'prop-types'

import {useEffect, useMemo, useState} from 'react'

const TablePagination = ({
  currentPageIndex,
  numberOfRowsPerPage,
  onPageChange,
  pageCount,
  setNumberOfRowsPerPage
}) => {
  const disableNext = useMemo(() => (
    currentPageIndex >= pageCount - 1
  ), [currentPageIndex, pageCount])

  const disablePrevious = useMemo(() => (
    currentPageIndex <= 0
  ), [currentPageIndex])

  const [
    pageInputValue,
    setPageInputValue
  ] = useState(String(currentPageIndex + 1))

  useEffect(() => {
    if (pageCount === 0)
      setPageInputValue('0')
  }, [pageCount])

  const handleNextButtonClick = () => {
    onPageChange(currentPageIndex + 1)
  }

  const handleNumberOfRowsPerPageChange = event => {
    setNumberOfRowsPerPage(Number(event.target.value))
  }

  const handlePageInputChange = event => {
    const newValue = event.target.value

    if ((/^[1-9]\d*$/).test(newValue) &&
      Number(newValue) >= 1 &&
      Number(newValue) <= pageCount)
      setPageInputValue(newValue)
  }

  const handlePageInputKeyDown = event => {
    const newValue = event.target.value

    if (event.key === 'Enter' &&
      (/^[1-9]\d*$/).test(newValue) &&
      Number(newValue) >= 1 &&
      Number(newValue) <= pageCount) {
      setPageInputValue(newValue)
      onPageChange(Number(newValue) - 1)
    }
  }

  const handlePreviousButtonClick = () => {
    onPageChange(currentPageIndex - 1)
  }

  return (
    <div className='-pagination table-pagination'>
      <div className='-previous'>
        <button
          className='-btn'
          disabled={disablePrevious}
          onClick={handlePreviousButtonClick}
          type='button'>
          Previous
        </button>
      </div>
      <div className='-center'>
        <span className='-pageInfo'>
          Page{' '}
          <div className='-pageJump'>
            <input
              aria-label='Enter a page number'
              inputMode='numeric'
              max={pageCount}
              min={1}
              onChange={handlePageInputChange}
              onKeyDown={handlePageInputKeyDown}
              pattern='[1-9]\d*'
              type='number'
              value={pageInputValue}
            />
          </div>
          {' '}of{' '}
          <span className='-totalPages'>{pageCount}</span>
        </span>
        <span className='select-wrap -pageSizeOptions'>
          <select
            aria-label='rows per page'
            value={numberOfRowsPerPage}
            onChange={handleNumberOfRowsPerPageChange}>
            {[5, 10, 20, 25, 50, 100].map(size => (
              <option key={size} value={size}>
                {`${size} rows`}
              </option>
            ))}
          </select>
        </span>
      </div>
      <div className='-next'>
        <button
          className='-btn'
          disabled={disableNext}
          onClick={handleNextButtonClick}>
          Next
        </button>
      </div>
    </div>
  )
}

TablePagination.propTypes = {
  currentPageIndex: PropTypes.number.isRequired,
  numberOfRowsPerPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  pageCount: PropTypes.number.isRequired,
  setNumberOfRowsPerPage: PropTypes.func.isRequired
}

export default TablePagination
